<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolDeltaSolSl_3d02"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSolSl_3d02 from '@/device-products/ResolDeltaSolSl_3d02.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSolSl_3d02, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
